import { DhlHeadline as NewHeadline } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for Headline component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Headline = (props) => {
  const { children, ...rest } = props;

  return <NewHeadline {...rest}>{children}</NewHeadline>;
};

Headline.propTypes = {
  children: PropTypes.node,
};

// Maintain static properties for backward compatibility
Headline.H1 = "h1";
Headline.H2 = "h2";
Headline.H3 = "h3";
Headline.H4 = "h4";
Headline.H5 = "h5";
Headline.H6 = "h6";

export default Headline;
